module.exports = __webpack_public_path__ + "static/media/11.458a4f8b.svg";